import createNamedWrapperReducer from "@redux/feature/Markets/Common/Reducers/wrapperReducer";
import { combineReducers } from "redux";
import PartnerProfDemMetNomSegReducer from "./reducer/partnerProfDemMetNomSeg";
import PartnerSummaryReducer from "./reducer/PartnerSummaryReducer";
export default combineReducers({
    partnerProfDemMetNomSeg: createNamedWrapperReducer(PartnerProfDemMetNomSegReducer, "partnerProfDemMetNomSeg"),
    partnerSummary: createNamedWrapperReducer(PartnerSummaryReducer, "partnerSummaryReducer"),
});
